import { dynamicField } from '../../store/form/utils';
import {
  formatBRL,
  formatBRLForList,
  formatCents,
  formatCentsForList,
  formatNumber,
} from '../../store/masks';
import { setNestedField } from '../../store/utils';
import Flex from '../Flex';
import Form from '../Form';
import useStore from '../Hooks/useStore';
import * as lodash from 'lodash';
interface ElementProps {
  elements: any;
}
const El = (props: any) => {
  const {
    children,
    type,
    inputType,
    bind,
    title,
    properties,
    onward,
    forward,
  } = props;

  const [getters, setters] = useStore();

  const {
    form: { getShowSingleForm, isBatchMode },
    banner: { getPromotionalPrices, getPrices },
  } = getters;

  const {
    form: { setBatchForm },
  } = setters;

  const isBatch = isBatchMode();

  const style =
    properties?.find(({ type }) => type === 'style')?.properties ?? {};

  const value = getShowSingleForm(bind);

  const onChange = (value) => {
    setBatchForm(bind, value, forward);
  };

  switch (inputType) {
    case 'row':
      return (
        <Flex.Row key={type} style={style}>
          {<Element elements={children} />}
        </Flex.Row>
      );

    case 'col':
      return (
        <Flex.Col key={type} style={style}>
          {<Element elements={children} />}
        </Flex.Col>
      );

    case 'date':
      return (
        <Form.Input.DatePicker
          key={type}
          label={title}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      );

    case 'price':
      return (
        <Form.Input.Dropdown
          className="form-banner-field"
          errorMessage={false}
          items={getPrices()}
          mask={formatBRLForList}
          unmask={formatCentsForList}
          label={title}
          value={value}
          disabled={isBatch}
          onChange={(e) => onChange(e.target.value)}
          onSelected={({ name }) => {
            setBatchForm(bind, Number(name));
          }}
        />
      );

    case 'promotion':
      return (
        <Form.Input.Dropdown
          key={type}
          className="form-banner-field"
          errorMessage={false}
          items={getPromotionalPrices()}
          mask={formatBRLForList}
          unmask={formatCentsForList}
          disabled={isBatch}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          label={title}
          onSelected={({ name }) => {
            setBatchForm(bind, Number(name));
          }}
        />
      );

    case 'text':
      return (
        <Form.Input
          className="form-banner-field"
          key={type}
          label={title}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          errorMessage={false}
        />
      );

    case 'percent':
      return (
        <Form.Input
          className="form-banner-field"
          mask={(input: number | string): number => {
            let number = typeof input === 'string' ? parseFloat(input) : input;
            if (isNaN(number)) {
              return 0;
            }
            number = Math.min(number, 100);
            let formattedNumber = number.toFixed(4);
            formattedNumber = Number(formattedNumber).toString();
            return Number(formattedNumber);
          }}
          unmask={(input: number | string): number => {
            let number = typeof input === 'string' ? parseFloat(input) : input;
            if (isNaN(number)) {
              return 0;
            }
            number = Math.min(number, 100);
            let formattedNumber = number.toFixed(4);
            formattedNumber = Number(formattedNumber).toString();
            return Number(formattedNumber);
          }}
          key={type}
          label={title}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          errorMessage={false}
        />
      );

    case 'integer':
      return (
        <Form.Input
          className="form-banner-field"
          mask={formatNumber}
          unmask={formatCentsForList}
          key={type}
          label={title}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          errorMessage={false}
        />
      );

    case 'currency':
      return (
        <Form.Input
          className="form-banner-field"
          key={type}
          label={title}
          mask={formatBRL}
          unmask={formatCents}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          errorMessage={false}
        />
      );

    case 'checkbox':
      return (
        <Form.Input.Checkbox
          key={type}
          label={title}
          className="form-banner-field"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
        />
      );

    default:
      return <>Unsolved Field Type</>;
  }
};

export default function Element({ elements }: ElementProps) {
  return (
    <>
      {elements.map((props) => (
        <El {...props} />
      ))}
    </>
  );
}
